function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "bell"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m18 13.171v-4.171c0-2.967-2.167-5.432-5-5.91v-.09c0-.553-.448-1-1-1s-1 .447-1 1v.09c-2.833.478-5 2.943-5 5.91v4.171c-1.164.413-2 1.525-2 2.829v2c0 .553.448 1 1 1h14c.553 0 1-.447 1-1v-2c0-1.304-.836-2.416-2-2.829zm0 3.829h-12v-1c0-.552.449-1 1-1 .552 0 1-.447 1-1v-5c0-2.206 1.794-4 4-4s4 1.794 4 4v5c0 .553.447 1 1 1 .552 0 1 .448 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13 20h-2c-.552 0-1 .447-1 1s.448 1 1 1h2c.553 0 1-.447 1-1s-.447-1-1-1z"
})));

var Svg008Bell = function Svg008Bell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg008Bell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/008-bell.90d24296.svg";
export { ForwardRef as ReactComponent };